import { createSlice } from "@reduxjs/toolkit";

const casesSlice = createSlice({
  name: "cases",
  initialState: {
    caseList: [],
    selectedCase: null,
    selectedCaseDetail: null,
    isLoading: false,
    error: false,
  },
  reducers: {
    fetchCasesStart: (state) => {
      state.isLoading = true;
      state.error = false;
    },
    fetchCasesSuccess: (state, action) => {
      state.isLoading = false;
      state.caseList = action.payload;
      state.error = false;
    },
    fetchCasesFailure: (state) => {
      state.isLoading = false;
      state.error = true;
    },
    setSelectedCase: (state, action) => {
      state.selectedCase = action.payload;
    },
    setSelectedCaseDetail: (state, action) => {
      state.selectedCaseDetail = action.payload;
    },
    updateModelInfos: (state, action) => {
      const { modelInfos } = action.payload;
      if (state.selectedCaseDetail) {
        state.selectedCaseDetail.modelInfos = modelInfos;
      }
    },
    updateSurgeryPos: (state, action) => {
      const { surgeryPos } = action.payload;
      if (state.selectedCaseDetail) {
        state.selectedCaseDetail.surgeryPos = surgeryPos;
      }
    },
    updateAnnotations: (state, action) => {
      const { actionType, annotationId, annotationData } = action.payload;

      if (!state.selectedCaseDetail) return;

      if (!state.selectedCaseDetail.annotations) {
        state.selectedCaseDetail.annotations = {};
      }

      switch (actionType) {
        case "add":
          state.selectedCaseDetail.annotations[annotationId] = annotationData;
          break;
        case "update":
          if (state.selectedCaseDetail.annotations[annotationId]) {
            state.selectedCaseDetail.annotations[annotationId] = {
              ...state.selectedCaseDetail.annotations[annotationId],
              ...annotationData,
            };
          }
          break;
        case "delete":
          delete state.selectedCaseDetail.annotations[annotationId];
          break;
        default:
          break;
      }
    },
    updateMeasurements: (state, action) => {
      const { actionType, measurementId, measurementData } = action.payload;

      if (!state.selectedCaseDetail) return;

      if (!state.selectedCaseDetail.measurements) {
        state.selectedCaseDetail.measurements = {};
      }

      switch (actionType) {
        case "add":
          state.selectedCaseDetail.measurements[measurementId] =
            measurementData;
          break;
        case "update":
          if (state.selectedCaseDetail.measurements[measurementId]) {
            state.selectedCaseDetail.measurements[measurementId] = {
              ...state.selectedCaseDetail.measurements[measurementId],
              ...measurementData,
            };
          }
          break;
        case "delete":
          delete state.selectedCaseDetail.measurements[measurementId];
          break;
        default:
          break;
      }
    },
    updateModelGroups: (state, action) => {
      const { modelGroups } = action.payload;
      if (state.selectedCaseDetail) {
        state.selectedCaseDetail.modelGroups = modelGroups;
      }
    },
  },
});

export const {
  fetchCasesStart,
  fetchCasesSuccess,
  fetchCasesFailure,
  setSelectedCase,
  setSelectedCaseDetail,
  updateModelInfos,
  updateSurgeryPos,
  updateAnnotations,
  updateMeasurements,
  updateModelGroups,
} = casesSlice.actions;

export default casesSlice.reducer;
